// File: client/src/variant/cardEffects/skipOpponent.js
//
// Effect kind: 'skip_opponent'
// Skip card — the opponent loses their next turn. The directive records how many
// opponent turns to skip; the turn controller (and, online, the server) is
// responsible for actually not handing control to the opponent.

const skipOpponent = {
  kind: 'skip_opponent',

  onPlay: ({ card, opponentColor }) => ({
    skipOpponentTurns: 1,
    message: `${card.name}: ${opponentColor} loses their next turn.`,
  }),
};

export default skipOpponent;
